const runtimeEnv = (typeof window !== 'undefined' && window._env_) || {};

const resolve = (key) => {
  const runtimeValue = runtimeEnv[key];
  if (runtimeValue !== undefined && runtimeValue !== '') {
    return runtimeValue;
  }
  return process.env[key];
};

export const API_URL = resolve('REACT_APP_API_URL');
export const STRIPE_PUBLISHABLE_KEY = resolve('REACT_APP_STRIPE_PUBLISHABLE_KEY');
export const GOOGLE_CLIENT_ID = resolve('REACT_APP_GOOGLE_CLIENT_ID');
export const GOOGLE_ADS_ID = resolve('REACT_APP_GOOGLE_ADS_ID') || '';
export const APP_VERSION = resolve('REACT_APP_VERSION') || 'dev';
export const INSTANCE_SLOT = resolve('REACT_APP_INSTANCE_SLOT') || 'stable';

// Suffix that turns a store slug into its public host, e.g. ".salovare.com"
// (prod) or "-test.salovare.com" (test). When a slug subdomain is detected the
// app resolves the store from the slug and hides the storeId from the URL.
// Empty on localhost, where the storeId stays in the path.
export const STORE_HOST_SUFFIX = resolve('REACT_APP_STORE_HOST_SUFFIX') || '';
